module.exports = __webpack_public_path__ + "monito_logo.svg?a102c5fd1d1189a6fbd893a6acf107fc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/monito_logo.svg
// module id = 28
// module chunks = 0